/**
 * Return a copy of `items` with those whose id is in `selectedIds` moved to the
 * front, preserving the original relative order within each group. Used by the
 * report filters so the user's current selection surfaces at the top of a list.
 */
export function sortSelectedFirst<T extends { id: number }>(
  items: T[],
  selectedIds: number[],
): T[] {
  if (selectedIds.length === 0) return items;
  const selected = new Set(selectedIds);
  const top: T[] = [];
  const rest: T[] = [];
  for (const item of items) {
    if (selected.has(item.id)) top.push(item);
    else rest.push(item);
  }
  return [...top, ...rest];
}
